import React from 'react';
import './Room.css'
import '../../App.css'
import '../home/home.css'
import Sec4ArrowSvg from '../../svgs/home/Sec4ArrowSvg'
import ImageSlide from './ImageSlide';
import AnimateIn from '../../screens/components/AnimateIn';
import InViewComponent from '../../screens/components/InView';
import { useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../hook/UseLang';
import CONTENT from '../../contents/rooms'
import roomData from '../../contents/roomData';
import Slider from 'react-slick';

const imgArr = [
    './images/rooms/new_room/0.jpg',
    './images/rooms/new_room/4.jpg',
    './images/rooms/new_room/1.jpg',
    './images/rooms/new_room/5.jpg',
    './images/rooms/new_room/2.jpg',
    './images/rooms/new_room/6.jpg',
    './images/rooms/new_room/3.jpg',
    './images/rooms/new_room/7.jpg',
    './images/rooms/new_room/9.jpg',
    './images/rooms/new_room/8.jpg',
]

const Room1 = ({}) => {
    const navigate = useNavigate()
    const [lang, setLang] = useLang()
    const icons = useMemo(() => 
        new Array(14).fill(0).map((_, i) => 
            <AnimateIn key={Math.random()} delay={(i + 1) * 60} className='min-w-[80px] flex flex-col items-center justify-center two-k-scale-12'>
                <img src={`./images/rooms/icons/icon_${i+1}.png`} className={``}></img>
                <div className='text-d-10 text-[#816A34] mt-[6px]'>{CONTENT[`icon_${i+1}`][lang]}</div>
            </AnimateIn>
        )
    ,[lang])
    const titleRef = useRef()
    const room1Ref1 = useRef()
    const room1Ref2 = useRef()
    const room1Ref3 = useRef()
    const room2Ref1 = useRef()
    const room2Ref2 = useRef()
    const room2Ref3 = useRef()
    const room3Ref1 = useRef()
    const room3Ref2 = useRef()
    const room3Ref3 = useRef()
    const room4Ref1 = useRef()
    const room4Ref2 = useRef()
    const room4Ref3 = useRef()
    const room5Ref1 = useRef()
    const room5Ref2 = useRef()
    const room5Ref3 = useRef()
    const ameRef = useRef()
    const bottomRef = useRef()
    const refArr = [
        [room1Ref1, room1Ref2, room1Ref3],
        [room2Ref1, room2Ref2, room2Ref3],
        [room3Ref1, room3Ref2, room3Ref3],
        [room4Ref1, room4Ref2, room4Ref3],
        [room5Ref1, room5Ref2, room5Ref3],
    ]
    const sliderRef = useRef()
    
    const RealSlider = useMemo(() => {
            const settings = {
                infinite: true,
                arrows: true,
                autoplay: true,
                speed: 500,
                autoplaySpeed: 3000,
                cssEase: "linear",
                variableWidth: true,
                // afterChange: (indexOfCurrentSlide) => {
                //     handleIdxChange(
                //     indexOfCurrentSlide
                //     )
                // },
                dots:false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
        
            };
        return <Slider ref={sliderRef} {...settings}>
            {imgArr.map((src, index) => (
                    <img key={index} className='h-[100%] px-[12px]' src={src} alt={`Slide ${index}`} />
            // <div key={index}>
            //     <div className='flex flex-row items-center justify-center max-w-[500px]' style={{aspectRatio: '1920/1080', overflow: 'hidden', height:'undefined'}}>
            //     </div>
            // </div>
            ))}
        </Slider>
    },[])
    const DATA = useMemo(() => {
        // console.log(Object.entries(roomData).map(([key, value]) => {return value}))
        return Object.entries(roomData).map(([key, value]) => {return value})
    }, [])
    return (
    <div className='relative w-full'>
        {/* sec1 */}
        <div className='w-full h-[50vh] addnavpadding relative'>
            <div className='absolute bottom-5 left-5 vert-text text-white text-[8px] font-[500] m-show-d-hidden'>No. 21 Whitfield Road Causeway Bay Hong Kong Island Hong Kong</div>
            <img src='./images/rooms/top-banner.png' className='w-full h-full' style={{objectFit:'cover'}}></img>
        </div>
        <div className='relative flex flex-row items-center justify-center h-[25vh] max-h-[400px]'>
            <div className='absolute vert-text text-[8px] text-[#9B998F] left-5 top-5 font-[500]'>info@21whitfieldseaview.com</div>
            <div className='flex flex-col items-center justify-center' style={{flex:1}}>
                <div ref={titleRef} className='title_text text-d-35 playfair-display'>{CONTENT.rooms[lang]}</div>
                <div className='text-[#0FBAB5]'>{CONTENT.listRooms[lang]}</div>
            </div>
            <div className='flex flex-row items-center justify-center flex-wrap' style={{flex:1}}>
                <div className='flex flex-wrap justify-start items-center  max-w-[467px]'>
                    {DATA.map((obj, i) => {
                        return (<>
                        <a href={`#${obj.title[lang]}`} className='text-d-12 cursor-pointer select-none hover:font-bold'>{obj.title[lang]}</a>
                        <div className='h-[10px] w-[1px] bg-black mx-[7px]'></div>
                    </>)
                    })}
                </div>
            </div>
        </div>
        <InViewComponent reffing={titleRef} active='title_text_active'delay={2000}/>
        {/* sec2 */}
        <div className='w-full flex flex-row items-center justify-center flex-wrap' style={{gap:12}}>
            {DATA.map((obj,i) => {
                return (
                    <AnimateIn delay={1500} time={400 * (i + 1)}>
                        <div key={obj.title[lang] + i} className='relative w-[300px] flex flex-row items-center justify-center h-[300px] mb-[12px]' style={{flex:  1}}>
                            <div id={obj.title[lang]} className='absolute top-[-200px]'></div>
                            <div className='bg-[#9B998F] h-full' style={{flex:0.1, height:'100%'}}>
                                
                            </div>
                            <div className='relative h-full w-full' style={{flex:2}}>
                                <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                                <div className='w-full h-full flex flex-col items-start justify-center relative d-px24-m-py12' style={{gap:24}}>
                                    <div className='w-full'>
                                        <div ref={refArr[i][0]} className='title_text text-d-20 font-bold poltawski-nowy'>{obj.title[lang]}</div>
                                        <div className='w-[70%] h-[1px] bg-[#0FBAB5]'></div>
                                    </div>
                                    <div ref={refArr[i][1]} className='title_text text-d-12'>{obj.text[lang]}</div>
                                    <div ref={refArr[i][2]} className='title_text text-d-12'>
                                        {/* <div><span className='mr-[12px] font-bold'>{CONTENT.capacity[lang]}</span>{obj.capacity[lang]}</div> */}
                                        {/* <div><span className='mr-[12px] font-bold'>{CONTENT.roomSize[lang]}</span>{obj.room[lang]}</div> */}
                                        <div><span className='mr-[12px] font-bold'>{CONTENT.bedSize[lang]}</span>{obj.bed[lang]}</div>
                                        <div><span className='mr-[12px] font-bold'>{obj.des[lang]}</span></div>
                                    </div>
                                </div>
                            </div>
                            {/* <ImageSlide data={obj}row={i+1}/> */}
                        </div>
                        <InViewComponent reffing={refArr[i][0]} active='title_text_active'delay={0}/>
                        <InViewComponent reffing={refArr[i][1]} active='title_text_active'delay={0}/>
                        <InViewComponent reffing={refArr[i][2]} active='title_text_active'delay={0}/>

                    </AnimateIn>
                )
            })}
        </div>
        <div className='w-full flex flex-row items-center justify-center my-[48px]'>            
            <div className='relative w-[90%] h-[500px]' >
                {RealSlider}
            </div>
        </div>
        {/* sec3 */}
        <div className='relative w-full flex flex-row-col items-center justify-center min-h-[322px] x-padding' style={{gap:36}}>
            <div id='amenity' className='absolute top-[-110px] left-0'></div>
            <div className='w-full h-full flex flex-col items-center-start justify-center' style={{flex:1}}>
                <div className='flex flex-col items-start justify-center' style={{flex:1}}>
                    <div ref={ameRef} className='title_text text-d-35 font-bold playfair-display'>{CONTENT.amenity[lang]}</div>
                    <InViewComponent reffing={ameRef} active='title_text_active' delay={0}/>
                    <div className='text-d-12 text-[#0FBAB5] mt-[35px]'>{CONTENT.amenity_1[lang]}</div>
                    <div className='text-d-12'>{CONTENT.amenity_2[lang]}</div>
                </div>
            </div>
            <div className='grid grid-cols-2 gap-12 md:grid-cols-4 lg:grid-cols-7' style={{flex:2}}>
                {icons}
            </div>
        </div>
        {/* sec4 */}
        <div className='w-full min-h-[422px] relative flex flex-row items-center justify-center'>
            <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
            <div className='relative w-full h-full flex flex-row items-center justify-center'>
                <div className='w-[90%] max-w-[1123px] flex flex-col items-center justify-center bg-[#fff] opacity-[0.8] py-[57px] px-[12px] text-center'>
                    <div ref={bottomRef} className='title_text text-d-12'>{CONTENT.faq_1[lang]}</div>
                    <InViewComponent reffing={bottomRef} active='title_text_active' delay={0}/>
                    <div onClick={() => navigate('/faq')} className='btn-arrow mt-[48px] text-d-12 px-[88px] py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300'>
                        <div className='poltawski-nowy'>{CONTENT.faq_0[lang]}</div>
                        <div className='absolute right-[-14%] top-[46%] arrow-moveleft'>
                            <Sec4ArrowSvg/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};

export default Room1;